import $ from 'jquery';
import UI from 'root/ui';
import Cache from 'root/cache';
import Constants from 'root/constants';
import Router from 'root/router';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    className: 'user-profile',

    events: {
        'click .avatar'             : 'onToggleDropdown',
        'click .edit-profile'       : 'onEditProfile',
        'click .edit-notifications' : 'onEditNotifications',
        'click .portal-settings'    : 'onOpenPortalSettings',
        'click .sign-in'            : 'onSignIn',
        'click .sign-out'           : 'onSignOut',
        'click .sign-up'            : 'onSignUp'
    },

    dom_handlers: {
        onToggleDropdown: function(e) {
            if (Cache.guest_user && Cache.guest_user.get('type') === 'portal_guest') {
                return;
            }

            this.$el.toggleClass('open');
        },

        onEditProfile: function(e) {
            e.preventDefault();

            Router.addQueryString('profile', 'edit', {trigger: false});

            if (Cache.real_user_id || Cache.portal_user) {
                Modals.editProfile(function() {
                    Router.removeQueryString('profile');
                });
            } else if (Cache.guest_user) {
                Modals.portalGuest(function() {
                    Router.removeQueryString('profile');
                }, true);
            }
        },

        onEditNotifications: function(e) {
            e.preventDefault();

            if (Cache.real_user_id) {
                window.location = this.portal.get('workspace_url') + '/project/?notification=1';
            } else if (Cache.portal_user) {
                Modals.editPortalNotifications();
            }
        },

        onOpenPortalSettings: function(e) {
            e.preventDefault();

            Modals.portalSettings(this.portal, () => {
                Router.removeQueryString('settings');
            });

            Router.addQueryString('settings', 1);
        },

        onSignIn: function(e) {
            e.preventDefault();

            Modals.signIn(() => {
                window.location.href = this.portal.getUrl();
            });
        },

        onSignOut: function(e) {
            e.preventDefault();

            if (Cache.guest_user) {
                Cache.removeGuestUser();
            }

            Cache.app.request({
                action: 'app/logout',
                success: () => {
                    window.location.href = this.portal.getUrl();
                }
            });
        },

        onSignUp: function(e) {
            e.preventDefault();

            Modals.portalSignup();
        },

        onDocumentClick: function(e) {
            if ($(e.target).hasClass('.avatar') || $(e.target).parents('.avatar').length) {
                return;
            }

            if ($(e.target).hasClass('.profile-dropdown') || $(e.target).parents('.profile-dropdown').length) {
                return;
            }

            this.$el.removeClass('open');
        }
    },

    event_handlers: {
        onProfilePicChange: function() {
            this.$el.find('.avatar > img').attr('src', this.model.getAvatar(36));
            this.$el.find('.photo').css('background-image', 'url(' + this.model.getAvatar(68) + ')');
        },
    },

    initialize: function(options) {
        this.portal = options.portal;

        if (Cache.real_user_id && Cache.getRealUser()) {
            this.model = Cache.getRealUser();

            this.listenTo(this.model, 'change:name', this.render);
        } else if (Cache.portal_user) {
            this.model = Cache.portal_user;

            this.listenTo(this.model, 'change:display_name', this.render);
        } else {
            Cache.app.dispatcher.on('Portal:guestUpdate', this.render.bind(this));
        }

        this.listenTo(this.model, 'change:avatar',             this.event_handlers.onProfilePicChange.bind(this));
        this.listenTo(this.model, 'change:email',              this.render);
        this.listenTo(this.model, 'change:is_email_confirmed', this.render);

        this.on('remove', function() {
            $(document).off('click.portal_profile');
        });

        $(document).on('click.portal_profile', this.dom_handlers.onDocumentClick.bind(this));
    },

    onRender: function() {
        var query_string = Router.getQueryString();

        if (query_string.profile && query_string.profile === 'edit') {
            this.$el.find('.edit-profile').click();
        } else if (query_string.notifications && query_string.notifications === 'edit') {
            if (Cache.portal_user) {
                Modals.editPortalNotifications();
            }
        } else if (query_string.settings && Cache.app.isAdmin()) {
            this.$el.find('.portal-settings').click();
        }
    },

    render: function() {
        var content = '';

        if (this.model) {
            content += '<div class="avatar"><img src="' + this.model.getAvatar(64) + '"></div>';

            var workspace_member = Cache.workspace_member.findWhere({user_id: Cache.real_user_id && Cache.getRealUser().id});

            content += '<div class="profile-dropdown dropdown-box">' +
                            '<div class="photo-box">' +
                                '<div class="photo" style="background-image:url(' + this.model.getAvatar(64) + ')"></div>' +
                            '</div>' +
                            '<div class="profile-details">' +
                                '<div class="profile-name">' + (Cache.real_user_id ? this.model.escape('name') : this.model.escape('display_name'))  + '</div>' +
                                '<div class="profile-email">' + this.model.escape('email') + '</div>' +
                                '<div class="profile-role">' +
                                    (workspace_member && workspace_member.get('role') === Constants.ADMIN    ? '<span class="badge-primary-invert font-weight-medium">Admin</span>' : '') +
                                    (workspace_member && workspace_member.get('role') === Constants.ASSIGNEE ? '<span class="badge-primary-invert font-weight-medium">Collaborator</span>' : '') +
                                    (workspace_member && workspace_member.get('role') === Constants.CLIENT   ? '<span class="badge-primary-invert font-weight-medium">Guest</span>' : '') +
                                    (!Cache.real_user_id && Cache.guest_user                                      ? '<span class="badge-primary-invert font-weight-medium">Visitor</span>' : '') +
                                '</div>' +
                            '</div>' +
                            '<a class="edit-profile" href="#"><i class="far fa-fw fa-id-badge"></i>My Profile' + (Cache.portal_user && !Cache.portal_user.get('is_email_confirmed') ? '<span class="text-warning margin-left-8 tooltip" data-title="Your email address isn\'t confirmed"><i class="fas fa-exclamation-circle"></i></span>' : '') + '</a>' +
                            '<a class="edit-notifications" href="#"><i class="far fa-fw fa-bell"></i>Notifications</a>' +
                            (Cache.app.isAdmin() ?
                            '<a href="#" class="portal-settings"><i class="far fa-fw fa-cog"></i>Portal Settings</a>' : '') +
                            '<a href="/login/" class="sign-out"><i class="far fa-fw fa-sign-out"></i>Sign Out</a>' +
                        '</div>';
        } else if (Cache.guest_user) {
            content += '<div class="avatar' + (Cache.guest_user.get('type') === 'portal_guest' ? ' avatar-static' : '') + '">' +
                           (Cache.guest_user.get('avatar') ?
                           '<img src="' + Cache.guest_user.get('avatar') + '">' :
                           '<img src="' + Util.gravatar(Cache.guest_user.get('email'), 64, Cache.guest_user.get('name')) + '">') +
                       '</div>';

            // signed in via gl=xxxx from portal embed
            if (Cache.guest_user.get('type') === 'portal_guest') {
                // no profile management for portal guests
            } else {
                content +=
                '<div class="profile-dropdown dropdown-box">' +
                    '<div class="photo-box">' +
                        '<div class="photo" style="background-image:url(' + Util.gravatar(Cache.guest_user.get('email'), 64, Cache.guest_user.get('name')) + ')"></div>' +
                    '</div>' +
                    '<div class="profile-details">' +
                        '<div class="profile-name">' + Util.htmlEntities(Cache.guest_user.get('name')) + '</div>' +
                        '<div class="profile-email">' + Util.htmlEntities(Cache.guest_user.get('email')) + '</div>' +
                        '<div class="profile-role">' +
                            '<span class="badge-secondary-invert font-weight-medium">Visitor</span>' +
                        '</div>' +
                    '</div>' +
                    '<a class="edit-profile" href="#"><i class="far fa-fw fa-id-badge"></i>My Profile</a>' +
                    '<a href="/login/" class="sign-out"><i class="far fa-fw fa-sign-out"></i>Sign Out</a>' +
                '</div>';
            }
        } else {
            content += '<a class="sign-in" href="#">Sign in</a>' +
                        '<span class="sign-in-separator">/</span>' +
                        '<a class="sign-up" href="#">Sign up</a>';
        }

        this.$el.html(content);

        if (!this.is_rendered) {
            this.onRender();
            this.is_rendered = true;
        }

        return this;
    }
});